import { debounce } from '@webikon/webentor-core/_utils';

const videoContainer = document.getElementById('js-landing-hero-video');
const videoSrc =
  videoContainer && videoContainer.getAttribute('data-video-src');

function initVideo() {
  if (window.innerWidth < 1024 || !videoSrc) {
    return;
  }

  // Check if video is already initialized
  if (videoContainer.querySelector('video')) {
    return;
  }

  const video = document.createElement('video');
  video.setAttribute('autoplay', 'autoplay');
  video.setAttribute('muted', 'muted');
  video.setAttribute('loop', 'loop');
  video.setAttribute('playsinline', 'playsinline');
  video.className = 'absolute inset-0 h-full w-full object-cover block';

  const source = document.createElement('source');
  source.setAttribute('src', videoSrc);
  source.setAttribute('type', 'video/mp4');

  video.appendChild(source);

  videoContainer.appendChild(video);

  video.muted = true; // Fixes chrome issue with autoplay
  video.play();
}

document.addEventListener('DOMContentLoaded', function () {
  initVideo();
});

window.addEventListener(
  'resize',
  debounce(function () {
    initVideo();
  }),
);
